import axios from "@/axios";
import { AxiosResponse } from "axios";
import {
  GetReportsResponse,
  GetReportResponse,
  GetDimensionsResponse,
  GetMetricsResponse,
  GetBiddersResponse,
  GetAdunitGroupsResponse,
  GetDomainsResponse,
  EditReportResponse,
  GenerateReportResponse,
  GetReportsFileResponse,
  GetParameter,
  Update,
  Create,
} from "@/features/analytics/types";

export function getReports(): Promise<AxiosResponse<GetReportsResponse>> {
  return axios.get<GetReportsResponse>(`/reports/`);
}

export function getReport(reportId: string): Promise<AxiosResponse<GetReportResponse>> {
  return axios.get<GetReportResponse>(`/reports/${reportId}/`);
}

export function getDimensions(reportType: number): Promise<AxiosResponse<GetDimensionsResponse>> {
  return axios.get<GetDimensionsResponse>(`/dimensions/`, {
    params: {
      reportType: reportType,
    },
  });
}

export function getMetrics(reportType: number): Promise<AxiosResponse<GetMetricsResponse>> {
  return axios.get<GetMetricsResponse>(`/metrics/`, {
    params: {
      reportType: reportType,
    },
  });
}

export function getBidders(getArg: GetParameter): Promise<AxiosResponse<GetBiddersResponse>> {
  return axios.get<GetBiddersResponse>(`/publishers/${getArg.publisherId}/vendors/`, {
    params: {
      page: getArg.page,
      name: getArg.name,
    },
  });
}

export function getAdunitGroup(
  getArg: GetParameter
): Promise<AxiosResponse<GetAdunitGroupsResponse>> {
  return axios.get<GetAdunitGroupsResponse>(`/publishers/${getArg.publisherId}/adunit-groups/`, {
    params: {
      page: getArg.page,
      name: getArg.name,
    },
  });
}

export function getDomains(
  reportType: number,
  getArg: GetParameter
): Promise<AxiosResponse<GetDomainsResponse>> {
  return axios.get<GetDomainsResponse>(`/publishers/${getArg.publisherId}/domains/`, {
    params: {
      reportType: reportType,
      page: getArg.page,
      name: getArg.name,
    },
  });
}

export function saveReport(data: Create): Promise<AxiosResponse<EditReportResponse>> {
  return axios.post<EditReportResponse>(`/reports/`, data);
}

export function updateReport(
  data: Update,
  reportId: string
): Promise<AxiosResponse<EditReportResponse>> {
  return axios.put<EditReportResponse>(`/reports/${reportId}/`, data);
}

export function deleteReport(reportId: number | undefined): Promise<AxiosResponse<void>> {
  return axios.delete(`/reports/${reportId}/`);
}

export function generateReport(reportId: number, language: string): Promise<AxiosResponse<GenerateReportResponse>> {
  return axios.post<GenerateReportResponse>(`/reports/${reportId}/`, {
    params: {
      language: language,
    },
  });
}

export function getReportsFile(jobId: string): Promise<AxiosResponse<GetReportsFileResponse>> {
  return axios.get<GetReportsFileResponse>(`/reports/file/${jobId}/`);
}
